"use client"
import {Card, Flex, Text, TextInput, Title, UnstyledButton} from "@mantine/core";
import {COLORS} from "src/constants";
import {useForm} from "@mantine/form";
import {APPEAL_STATUS, APPEAL_TYPE, AppealsForm, createAppeal} from "src/entities/appeals";
import {useTranslation} from "react-i18next";

const inputStyles = {
    input: {
        backgroundColor: "#4F5DC4",
        borderRadius: "16px",
        fontSize: "18px",
        padding: "8px 16px",
        color: "white",
        border: "none"
    }
}

type Props = {productId?: number, close?: () => void}

export const AppealFeature = ({productId,close}: Props) => {
    const {t } = useTranslation()
    const form = useForm<AppealsForm>({
        initialValues: {
            name: "",
            phoneNumber: "",
            status: APPEAL_STATUS.UNREAD,
            type: APPEAL_TYPE.MAIN_PAGE,
            email: "",
            productId,
        }
    });

    const handleSubmit = async () => {
        if(close){
            close()
        }
        await createAppeal(form.values)
        form.reset()
    }

    return(
        <Card w="100%" maw={{base: "none", md: 340}}  bg={COLORS.PRIMARY_BG} p={24} style={{borderRadius: "24px"}}>
            <Title mb={24} lh={1.4} fz={20} fw={600} c={COLORS.PRIMARY_COLOR}>
                Оставьте заявку и получите скидку
            </Title>
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <Flex direction="column" w="100%" gap={10}>
                    <TextInput
                        placeholder={t("table.name")}
                        styles={inputStyles}
                        {...form.getInputProps("name")}
                    />
                    <TextInput
                        placeholder={t("form.label.phone")}
                        styles={inputStyles}
                        {...form.getInputProps("phoneNumber")}
                    />
                    <TextInput
                        placeholder={t("form.label.email")}
                        styles={inputStyles}
                        {...form.getInputProps("email")}
                    />
                    <Text lh={1.2} mb={24} fz={14} c="#9AA2DD">
                        <span style={{color: "#E9EBF8"}}>{t("section.titles.by-sending")}</span> <br/>
                        {t("section.titles.politic")}
                    </Text>
                    <Flex w="100%" justify="end">
                        <UnstyledButton type="submit" bg="#FAFAFA" style={{ borderRadius: "100px"}}
                                        px={24} py={14} fw={600} fz={16} c={COLORS.TRIOTERY_COLOR}>
                            {t("button.send")}
                        </UnstyledButton>
                    </Flex>
                </Flex>
            </form>
        </Card>
    )
}